import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrl } from '../constants/apiUrl';
import { Movement } from '../models/entities/movement';
import { VDealerReport } from '../models/entities/v-dealer-report';
import { VMovement } from '../models/entities/v-movement';
import { ListResponseModel } from '../models/responseModels/list-response-model';
import { ObjectResponseModel } from '../models/responseModels/object-response-model';
import { ResponseModel } from '../models/responseModels/response-model';

@Injectable({
  providedIn: 'root'
})
export class MovementService {

  constructor(private httpClient: HttpClient) { }


  getList(year: number, month: number, startDay: string, endDay: string): Observable<ListResponseModel<VMovement>> {
    return this.httpClient.get<ListResponseModel<VMovement>>(ApiUrl.url + "Movement/getList?year=" + year + "&month=" + month + "&startDay=" + startDay + "&endDay=" + endDay);
  }

  getDealerReport(): Observable<ListResponseModel<VDealerReport>> {
    return this.httpClient.get<ListResponseModel<VDealerReport>>(ApiUrl.url + "Movement/getDealerReport");
  }

  getById(id: number): Observable<ObjectResponseModel<Movement>> {
    return this.httpClient.get<ObjectResponseModel<Movement>>(ApiUrl.url + "Movement/getById?Id=" + id);
  }

  add(movement: Movement) {
    return this.httpClient.post<ObjectResponseModel<Movement>>(ApiUrl.url + "Movement/add", movement);
  }

  addRange(movements: Movement[]) {
    return this.httpClient.post<ObjectResponseModel<Movement>>(ApiUrl.url + "Movement/addRange", movements);
  }

  update(movement: Movement) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Movement/update", movement);
  }

  delete(id: number) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Movement/delete?Id=" + id, "");
  }
}
